module.exports = __webpack_public_path__ + "files/cee9ed8e3c09bfa57d6f55b815149b49.png";